import { FirebaseMessaging } from "@capacitor-firebase/messaging";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase/client";
import { currentDeviceId } from "../security/deviceSessions";

export async function enablePushForCurrentDevice(uid: string): Promise<boolean> {
  const supported = await FirebaseMessaging.isSupported().catch(() => ({ isSupported: false }));
  if (!supported.isSupported) return false;
  const permission = await FirebaseMessaging.requestPermissions();
  if (permission.receive !== "granted") return false;
  const { token } = await FirebaseMessaging.getToken();
  const deviceId = await currentDeviceId();
  await setDoc(doc(db, "users", uid, "devices", deviceId), {
    pushToken: token,
    pushEnabled: true,
    pushUpdatedAt: serverTimestamp()
  }, { merge: true });
  return true;
}

export async function disablePushForCurrentDevice(uid: string): Promise<void> {
  const deviceId = await currentDeviceId();
  await FirebaseMessaging.deleteToken().catch(() => undefined);
  await setDoc(doc(db, "users", uid, "devices", deviceId), {
    pushToken: null,
    pushEnabled: false,
    pushUpdatedAt: serverTimestamp()
  }, { merge: true });
}
